module.exports = __webpack_public_path__ + "static/media/cases_logos_eventos_02.7e1720c1.jpg";